import { OPEN_BLOCKED_USER_ALERT } from './types';

export const showBlockedUserErrorAlert = open => distpach =>
  distpach({
    type: OPEN_BLOCKED_USER_ALERT,
    payload: open
  });
